import React, { useState } from 'react';
import { CommandCenterLayout } from '../../components/layout/CommandCenterLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { Search, Filter, Download, CheckCircle2, XCircle, Clock, ExternalLink, Instagram, Facebook, Youtube, Twitter, MoreHorizontal, Eye } from 'lucide-react';
// Mock Data for Pivot Table
const mockPivotData = [{
  id: 1,
  region: 'DKI Jakarta',
  type: 'Provinsi',
  distributor: 'Andi Pratama',
  instagram: {
    status: 'validated',
    url: '#',
    date: '12 Feb'
  },
  tiktok: {
    status: 'submitted',
    url: '#',
    date: '13 Feb'
  },
  facebook: {
    status: 'pending',
    url: null,
    date: null
  },
  youtube: {
    status: 'validated',
    url: '#',
    date: '12 Feb'
  },
  score: 85
}, {
  id: 2,
  region: 'Kota Surabaya',
  type: 'Kab/Kota',
  distributor: 'Budi Santoso',
  instagram: {
    status: 'validated',
    url: '#',
    date: '10 Feb'
  },
  tiktok: {
    status: 'validated',
    url: '#',
    date: '10 Feb'
  },
  facebook: {
    status: 'validated',
    url: '#',
    date: '11 Feb'
  },
  youtube: {
    status: 'pending',
    url: null,
    date: null
  },
  score: 92
}, {
  id: 3,
  region: 'Kota Bandung',
  type: 'Kab/Kota',
  distributor: 'Andi Pratama',
  instagram: {
    status: 'rejected',
    url: '#',
    date: '14 Feb'
  },
  tiktok: {
    status: 'pending',
    url: null,
    date: null
  },
  facebook: {
    status: 'pending',
    url: null,
    date: null
  },
  youtube: {
    status: 'pending',
    url: null,
    date: null
  },
  score: 40
}, {
  id: 4,
  region: 'Kab. Bekasi',
  type: 'Kab/Kota',
  distributor: 'Siti Aminah',
  instagram: {
    status: 'validated',
    url: '#',
    date: '15 Feb'
  },
  tiktok: {
    status: 'pending',
    url: null,
    date: null
  },
  facebook: {
    status: 'pending',
    url: null,
    date: null
  },
  youtube: {
    status: 'pending',
    url: null,
    date: null
  },
  score: 60
}, {
  id: 5,
  region: 'Jawa Barat',
  type: 'Provinsi',
  distributor: 'Budi Santoso',
  instagram: {
    status: 'validated',
    url: '#',
    date: '11 Feb'
  },
  tiktok: {
    status: 'validated',
    url: '#',
    date: '11 Feb'
  },
  facebook: {
    status: 'validated',
    url: '#',
    date: '11 Feb'
  },
  youtube: {
    status: 'validated',
    url: '#',
    date: '11 Feb'
  },
  score: 100
}];
export function ProgressDistribusiPage() {
  const [selectedCampaign, setSelectedCampaign] = useState('CMP-001');
  const [filterStatus, setFilterStatus] = useState('all'); // all, validated, pending, rejected
  const [searchTerm, setSearchTerm] = useState('');
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'validated':
        return <CheckCircle2 className="h-5 w-5 text-green-500" data-id="element-2255" />;
      case 'submitted':
        return <Clock className="h-5 w-5 text-blue-500" data-id="element-2256" />;
      case 'rejected':
        return <XCircle className="h-5 w-5 text-red-500" data-id="element-2257" />;
      default:
        return <div className="h-2 w-2 rounded-full bg-gray-300 mx-auto" data-id="element-2258" />;
    }
  };
  const filteredData = mockPivotData.filter(row => row.region.toLowerCase().includes(searchTerm.toLowerCase()));
  return <CommandCenterLayout title="Monitoring Distribusi" subtitle="Pantau progress postingan per wilayah secara real-time" data-id="element-2259">
      <div className="space-y-6" data-id="element-2260">
        {/* Filters */}
        <Card data-id="element-2261">
          <CardContent className="p-4" data-id="element-2262">
            <div className="flex flex-col gap-4" data-id="element-2263">
              <div className="flex flex-col md:flex-row gap-4 justify-between" data-id="element-2264">
                <div className="flex-1 flex gap-4" data-id="element-2265">
                  <div className="w-full md:w-64" data-id="element-2266">
                    <label className="text-xs font-medium text-gray-500 mb-1 block" data-id="element-2267">
                      Pilih Campaign
                    </label>
                    <Select value={selectedCampaign} onChange={e => setSelectedCampaign(e.target.value)} data-id="element-2268">
                      <option value="CMP-001" data-id="element-2269">Kampanye HPSN 2025</option>
                      <option value="CMP-002" data-id="element-2270">Sosialisasi Bank Sampah</option>
                    </Select>
                  </div>
                  <div className="w-full md:w-48" data-id="element-2271">
                    <label className="text-xs font-medium text-gray-500 mb-1 block" data-id="element-2272">
                      Wilayah
                    </label>
                    <Select data-id="element-2273">
                      <option data-id="element-2274">Semua Wilayah</option>
                      <option data-id="element-2275">Jawa</option>
                      <option data-id="element-2276">Sumatera</option>
                      <option data-id="element-2277">Kalimantan</option>
                    </Select>
                  </div>
                  <div className="w-full md:w-48" data-id="element-2278">
                    <label className="text-xs font-medium text-gray-500 mb-1 block" data-id="element-2279">
                      Distributor (PIC)
                    </label>
                    <Select data-id="element-2280">
                      <option data-id="element-2281">Semua PIC</option>
                      <option data-id="element-2282">Andi Pratama</option>
                      <option data-id="element-2283">Budi Santoso</option>
                    </Select>
                  </div>
                </div>
                <div className="flex items-end gap-2" data-id="element-2284">
                  <Button variant="outline" className="gap-2" data-id="element-2285">
                    <Download className="h-4 w-4" data-id="element-2286" /> Export Excel
                  </Button>
                </div>
              </div>

              {/* Status Filter Chips */}
              <div className="flex gap-2 border-t pt-4" data-id="element-2287">
                {['All', 'Validated', 'Submitted', 'Pending', 'Rejected'].map(status => <button key={status} onClick={() => setFilterStatus(status.toLowerCase())} className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors ${filterStatus === status.toLowerCase() ? 'bg-primary-50 border-primary-200 text-primary-700' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50'}`} data-id="element-2288">
                      {status}
                    </button>)}
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Pivot Table */}
        <Card className="overflow-hidden" data-id="element-2289">
          <div className="p-4 border-b flex justify-between items-center" data-id="element-2290">
            <div className="relative w-64" data-id="element-2291">
              <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-2292" />
              <Input placeholder="Cari daerah..." className="pl-9 h-9" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-2293" />
            </div>
            <div className="text-sm text-gray-500" data-id="element-2294">
              Menampilkan {filteredData.length} dari {mockPivotData.length}{' '}
              daerah
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-2295">
            <table className="w-full text-sm text-left" data-id="element-2296">
              <thead className="bg-gray-50 text-gray-700 font-medium border-b" data-id="element-2297">
                <tr data-id="element-2298">
                  <th className="px-4 py-3 min-w-[200px]" data-id="element-2299">Nama Daerah</th>
                  <th className="px-4 py-3 text-center w-24" data-id="element-2300">
                    <div className="flex flex-col items-center gap-1" data-id="element-2301">
                      <Instagram className="h-4 w-4 text-pink-600" data-id="element-2302" />
                      <span className="text-xs" data-id="element-2303">Instagram</span>
                    </div>
                  </th>
                  <th className="px-4 py-3 text-center w-24" data-id="element-2304">
                    <div className="flex flex-col items-center gap-1" data-id="element-2305">
                      <span className="text-xs font-bold" data-id="element-2306">TT</span>
                      <span className="text-xs" data-id="element-2307">TikTok</span>
                    </div>
                  </th>
                  <th className="px-4 py-3 text-center w-24" data-id="element-2308">
                    <div className="flex flex-col items-center gap-1" data-id="element-2309">
                      <Facebook className="h-4 w-4 text-blue-600" data-id="element-2310" />
                      <span className="text-xs" data-id="element-2311">Facebook</span>
                    </div>
                  </th>
                  <th className="px-4 py-3 text-center w-24" data-id="element-2312">
                    <div className="flex flex-col items-center gap-1" data-id="element-2313">
                      <Youtube className="h-4 w-4 text-red-600" data-id="element-2314" />
                      <span className="text-xs" data-id="element-2315">YouTube</span>
                    </div>
                  </th>
                  <th className="px-4 py-3 text-center w-24" data-id="element-2316">Skor</th>
                  <th className="px-4 py-3 text-center w-16" data-id="element-2317"></th>
                </tr>
              </thead>
              <tbody className="divide-y" data-id="element-2318">
                {filteredData.map(row => <tr key={row.id} className="hover:bg-gray-50 transition-colors group" data-id="element-2319">
                    <td className="px-4 py-3" data-id="element-2320">
                      <div className="font-medium text-gray-900" data-id="element-2321">
                        {row.region}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-2322">
                        {row.type} • PIC: {row.distributor}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-center border-l bg-gray-50/30" data-id="element-2323">
                      <div className="flex justify-center group/cell relative cursor-pointer" title={`Status: ${row.instagram.status}`} data-id="element-2324">
                        {getStatusIcon(row.instagram.status)}
                        {row.instagram.date && <span className="text-[10px] text-gray-400 block mt-1" data-id="element-2325">
                            {row.instagram.date}
                          </span>}
                        {row.instagram.url && <a href={row.instagram.url} target="_blank" rel="noreferrer" className="absolute -right-2 -top-2 opacity-0 group-hover/cell:opacity-100 p-1 bg-white shadow rounded-full border z-10" onClick={e => e.stopPropagation()} data-id="element-2326">
                            <ExternalLink className="h-3 w-3 text-blue-600" data-id="element-2327" />
                          </a>}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-center border-l" data-id="element-2328">
                      <div className="flex justify-center group/cell relative" data-id="element-2329">
                        {getStatusIcon(row.tiktok.status)}
                        {row.tiktok.date && <span className="text-[10px] text-gray-400 block mt-1" data-id="element-2330">
                            {row.tiktok.date}
                          </span>}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-center border-l bg-gray-50/30" data-id="element-2331">
                      <div className="flex justify-center group/cell relative" data-id="element-2332">
                        {getStatusIcon(row.facebook.status)}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-center border-l" data-id="element-2333">
                      <div className="flex justify-center group/cell relative" data-id="element-2334">
                        {getStatusIcon(row.youtube.status)}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-center border-l font-bold" data-id="element-2335">
                      <span className={row.score >= 80 ? 'text-green-600' : row.score >= 50 ? 'text-yellow-600' : 'text-red-600'} data-id="element-2336">
                        {row.score}%
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center" data-id="element-2337">
                      <Button variant="ghost" size="sm" className="opacity-0 group-hover:opacity-100" data-id="element-2338">
                        <Eye className="h-4 w-4" data-id="element-2339" />
                      </Button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="p-4 border-t bg-gray-50 flex gap-6 text-xs text-gray-600 justify-center" data-id="element-2340">
            <div className="flex items-center gap-2" data-id="element-2341">
              <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-2342" /> Validated
            </div>
            <div className="flex items-center gap-2" data-id="element-2343">
              <Clock className="h-4 w-4 text-blue-500" data-id="element-2344" /> Submitted (Review)
            </div>
            <div className="flex items-center gap-2" data-id="element-2345">
              <XCircle className="h-4 w-4 text-red-500" data-id="element-2346" /> Rejected
            </div>
            <div className="flex items-center gap-2" data-id="element-2347">
              <div className="h-2 w-2 rounded-full bg-gray-300" data-id="element-2348" /> Belum Posting
            </div>
          </div>
        </Card>
      </div>
    </CommandCenterLayout>;
}